import { render } from "./TagSearchBar.vue?vue&type=template&id=21ddfc35&scoped=true"
import script from "./TagSearchBar.vue?vue&type=script&lang=js"
export * from "./TagSearchBar.vue?vue&type=script&lang=js"

import "./TagSearchBar.vue?vue&type=style&index=0&id=21ddfc35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ddfc35"]])

export default __exports__